import { render, staticRenderFns } from "./OPDDashboard.vue?vue&type=template&id=38633162&"
import script from "./OPDDashboard.vue?vue&type=script&lang=js&"
export * from "./OPDDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports